import {
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { useEffect, useState } from "react"

import { buscarHistoricoPedido } from "../../../services/integracao"

const useStyles = makeStyles(() => ({
    headerCell: {
        backgroundColor: "#6c8cff",
        color: "#fff",
        fontWeight: "bold",
        whiteSpace: "nowrap",
    },
    dataCell: {
        whiteSpace: "nowrap",
        verticalAlign: "top",
    },
    conteudo: {
        minWidth: 320,
    },
    estado: {
        padding: "24px 8px",
        textAlign: "center",
    },
}))

const formatarDataHora = valor => {
    if (valor === null || valor === undefined || valor === "") return "-"
    // O backend envia dataHora como epoch em milissegundos (Calendar.getTimeInMillis()).
    const data = typeof valor === "number" ? new Date(valor) : new Date(Number(valor) || valor)
    if (isNaN(data.getTime())) return "-"
    return data.toLocaleString("pt-BR")
}

/**
 * Popup do painel que mostra o histórico de um pedido (troca de status, pagamento, cancelamento,
 * alterações etc.). Consulta sob demanda o endpoint GET /pedido/historico/{idPedido} ao abrir.
 */
export default function DialogHistoricoPedido({ open, pedido, onClose }) {
    const classes = useStyles()

    const [carregando, setCarregando] = useState(false)
    const [erro, setErro] = useState("")
    const [historico, setHistorico] = useState([])

    useEffect(() => {
        if (!open || !pedido?.id) return

        let ativo = true
        const carregar = async () => {
            setCarregando(true)
            setErro("")
            const autorizacao = localStorage.getItem("chaveSistema")
            const resposta = await buscarHistoricoPedido(pedido.id, autorizacao)
            if (!ativo) return
            if (resposta?.retornoErro) {
                setErro(resposta.mensagem || "Não foi possível carregar o histórico do pedido.")
                setHistorico([])
            } else {
                setHistorico(resposta.historico || [])
            }
            setCarregando(false)
        }

        carregar()
        return () => {
            ativo = false
        }
    }, [open, pedido?.id])

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Histórico do pedido {pedido?.id ? `#${pedido.id}` : ""}</DialogTitle>
            <DialogContent dividers>
                {carregando ? (
                    <div className={classes.estado}>
                        <CircularProgress size={28} />
                    </div>
                ) : erro ? (
                    <div className={classes.estado}>
                        <Typography color="error">{erro}</Typography>
                    </div>
                ) : historico.length === 0 ? (
                    <div className={classes.estado}>
                        <Typography>Nenhum registro de histórico para este pedido.</Typography>
                    </div>
                ) : (
                    <Table size="small" className={classes.conteudo}>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.headerCell}>Data/Hora</TableCell>
                                <TableCell className={classes.headerCell}>Alteração</TableCell>
                                <TableCell className={classes.headerCell}>Responsável</TableCell>
                                <TableCell className={classes.headerCell}>Descrição</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {historico.map((item, index) => (
                                <TableRow key={item.id ?? index}>
                                    <TableCell className={classes.dataCell}>
                                        {formatarDataHora(item.dataHora)}
                                    </TableCell>
                                    <TableCell>{item.acao || "-"}</TableCell>
                                    <TableCell>{item.responsavel || "-"}</TableCell>
                                    <TableCell>{item.descricao || "-"}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </DialogContent>
        </Dialog>
    )
}
